'use client';
import Script from "next/script";

const inlineStyles = `
/*RADIO*/
.tsf-container :root {
  --color: rebeccapurple;
}

.tsf-container *,
.tsf-container *:before,
.tsf-container *:after {
  box-sizing: border-box;
}

.tsf-container .radio {
  display: grid;
  grid-template-columns: -webkit-min-content auto;
  grid-template-columns: min-content auto;
  grid-gap: 0.5em;
  font-size: 2.25rem;
  color: #ff6b01;
}
.tsf-container .radio:focus-within .radio__label {
  transform: scale(1.05);
  opacity: 1;
}

.tsf-container .radio__label {
  line-height: 1;
  transition: 180ms all ease-in-out;
  opacity: 0.8;
}

.tsf-container .radio__input {
  display: flex;
}
.tsf-container .radio__input input {
  opacity: 0;
  width: 0;
  height: 0;
}
.tsf-container .radio__input input:focus + .radio__control {
  box-shadow: 0 0 0 0.05em #fff, 0 0 0.15em 0.1em currentColor;
}

.tsf-container .radio-gradient input:checked + .radio__control {
  background: radial-gradient(currentcolor 50%, rgba(255, 0, 0, 0) 51%);
}

.tsf-container .radio-before .radio__control {
  display: grid;
  place-items: center;
}
.tsf-container .radio-before input + .radio__control::before {
  content: "";
  width: 0.5em;
  height: 0.5em;
  box-shadow: inset 0.5em 0.5em currentColor;
  border-radius: 50%;
  transition: 180ms transform ease-in-out;
  transform: scale(0);
}
.tsf-container .radio-before input:checked + .radio__control::before {
  transform: scale(1);
}

.tsf-container .radio__control {
  display: block;
  width: 1em;
  height: 1em;
  border-radius: 50%;
  border: 0.1em solid currentColor;
  transform: translateY(-0.05em);
}
/*END RADIO*/

.tsf-content {
    padding-bottom: 30px;
}
#parsley-id-multiple-ingredients {
    position: absolute;
    bottom:-30px;
}
#parsley-id-multiple-minoxidil-str, #parsley-id-multiple-finasteride-str {
    position: absolute;
}
.strengths {
    display:none;
}
.strengths.activeele {
    display:block;
}
.sticky-container {
    display:none !important;
}
.gsi-step-indicator.triangle li.current > * {
    color: #fff;
    background-color: #9fce8a;
    border-color: #9fce8a;
}
.col-form-label {
    width: 100%;
}
.capitalize {
    text-transform: capitalize;
}
#finished-product img {
    height:320px;
    margin-right:200px;
}

#finished-product h3, #finished-product p {
    display:inline-block;
}
#finished-product p {
    display:inline-block;
    margin-left:20px;
}

.clear-inline {
    display:block;
}

@media only screen and (max-width: 768px) {
    #finished-product img {
        height:300px;
        margin-right:0;
    }
    #finished-product h3, #finished-product p {
        display:block;
    }
    #finished-product p {
        margin-left:0;
    }
}

#tretinoin-solo, #azelaicacid-solo, #fluocinonide-solo, #progesterone-solo, #estradiol-solo, #ketoconazole-solo, #biotin-solo, #tacrolimus-solo, #caffeine-solo, #cetirizine-solo, #niacinamide-solo, #spironolactone-solo, #steroid-solo {
    display: none;
}

#call-for-pricing {
    display:none;
    font-weight:bold;
    text-align:center;
    margin-top:20px;
    font-size:1.2em;
}

#contact-us-button {
    border: none;
    font-family: 'Lato';
  font-size: inherit;
  color: inherit;
  background: none;
  cursor: pointer;
  padding: 25px 80px;
  display: inline-block;
  margin: 15px 30px;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: 700;
  outline: none;
  position: relative;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  transition: all 0.3s;
  background: #96c03d;
  color: #fff;
  padding: 25px 60px 25px 120px;
}

#contact-us-button:after {
    content: '';
  position: absolute;
  z-index: -1;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  transition: all 0.3s;
}

#contact-us-button:before {
    font-family: 'FontAwesome';
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  position: relative;
  -webkit-font-smoothing: antialiased;
  content: "\\f1d8";
  background: rgba(0,0,0,0.15);
  text-align: center;
}

#contact-us-button:hover {
  background: #b0e047;
}

#contact-us-button:active {
  background: #2c3e50;
  top: 2px;
}

#contact-us-button:before {
  position: absolute;
  height: 100%;
  left: 0;
  top: 0;
  line-height: 3;
  font-size: 140%;
  width: 60px;
}
`;

const inlineScript = `
function initHairWizard() {
    if (typeof jQuery === 'undefined' || typeof jQuery.fn.tsfWizard === 'undefined') {
        setTimeout(initHairWizard, 100);
        return;
    }
    jQuery(function($) {
        'use strict';
        (function($) {

            $('button').click(function(){
                if ($(this).is('#finish-button')) {
                    window.location.replace("https://www.cfspharmacy.com/custom-hair-loss#hair-pricing");
                }
                
                if ($('.tsf-wizard').attr('data-step-index') == 2 && $(this).attr('data-type') == 'next') {
                    var _ingredientsArray = [];
                    var _strengthsArray = []
                    var _ingredients = '';
                    var _strengths = '';
                    var _quantity = '';
                    var _form = '';
                    $(".tsf-content input").each(function(index){  
                        var input = $(this);
                        if ($(this).is(':checked')) {
                            if ($(this).attr('class') == 'ingredients') {
                                _ingredientsArray.push($(this).attr('id'));
                                _ingredients += $(this).attr('id') + ' / ';
                            } else if ($(this).attr('class') == 'strength') {
                                _strengthsArray.push($(this).attr('value'));
                                _strengths += $(this).attr('value') + ' / ';
                            } else if ($(this).attr('class') == 'quantity') {
                                _quantity = $(this).attr('value');
                            } else if ($(this).attr('class') == 'form') {
                                _form = $(this).attr('value');
                            }
                        }
                    });

                    //CALC PRICE
                    var _finalPrice = '';

                    if (_ingredientsArray.length == 1) { //if only 1 ingred
                        if (_ingredientsArray[0].toLowerCase() == 'minoxidil') {
                            if (_quantity == "30ml") {
                                _finalPrice = '$43.95';
                            } else if (_quantity == "60ml") {
                                _finalPrice = '$49.95';
                            } else {
                                _finalPrice = '$79.95';
                            }
                        } else if (_ingredientsArray[0].toLowerCase() == 'finasteride') { 
                            if (_quantity == "30ml") {
                                _finalPrice = '$49.95';
                            } else if (_quantity == "60ml") {
                                _finalPrice = '$59.95';
                            } else {
                                _finalPrice = '$94.95';
                            }
                        } else if (_ingredientsArray[0].toLowerCase() == 'latanoprost') {
                            if (_quantity == "30ml") {
                                _finalPrice = '$69.95';
                            } else if (_quantity == "60ml") {
                                _finalPrice = '$119.95';
                            } else {
                                _finalPrice = '$199.95';
                            }
                        } else if (_ingredientsArray[0].toLowerCase() == 'dutasteride') {
                            if (_quantity == "30ml") {
                                _finalPrice = '$69.95';
                            } else if (_quantity == "60ml") {
                                _finalPrice = '$119.95';
                            } else {
                                _finalPrice = '$199.95';
                            }
                        } else if (_ingredientsArray[0].toLowerCase() == 'bimatoprost') {
                            if (_quantity == "30ml") {
                                _finalPrice = '$69.95';
                            } else if (_quantity == "60ml") {
                                _finalPrice = '$119.95';
                            } else {
                                _finalPrice = '$199.95';
                            }
                        } else if (_ingredientsArray[0].toLowerCase() == 'tacrolimus') {
                            if (_quantity == "30ml") {
                                _finalPrice = '$84.95';
                            } else if (_quantity == "60ml") {
                                _finalPrice = '$114.95';
                            } else {
                                _finalPrice = '$189.95';
                            }
                        } else {
                            if (_quantity == "30ml") {
                                _finalPrice = '$50.95';
                            } else if (_quantity == "60ml") {
                                _finalPrice = '$60.95';
                            } else {
                                _finalPrice = '$100.95';
                            }
                        }
                    } else if (_ingredientsArray.length == 2) { //////////if 2 ingreds//////////////////////
                        if (_ingredientsArray.includes("dutasteride") && !_ingredientsArray.includes("latanoprost") && !_ingredientsArray.includes("bimatoprost") && !_ingredientsArray.includes("tacrolimus")) {
                            if (_quantity == "30ml") {
                                _finalPrice = '$72.95';
                            } else if (_quantity == "60ml") {
                                _finalPrice = '$128.95';
                            } else {
                                _finalPrice = '$202.95';
                            }
                        } else if (_ingredientsArray.includes("latanoprost") && !_ingredientsArray.includes("dutasteride") && !_ingredientsArray.includes("bimatoprost") && !_ingredientsArray.includes("tacrolimus")) {
                            if (_quantity == "30ml") {
                                _finalPrice = '$79.95';
                            } else if (_quantity == "60ml") {
                                _finalPrice = '$129.95';
                            } else {
                                _finalPrice = '$209.95';
                            }
                        } else if (_ingredientsArray.includes("bimatoprost") && !_ingredientsArray.includes("dutasteride") && !_ingredientsArray.includes("latanoprost") && !_ingredientsArray.includes("tacrolimus")) {
                            if (_quantity == "30ml") {
                                _finalPrice = '$79.95';
                            } else if (_quantity == "60ml") {
                                _finalPrice = '$129.95';
                            } else {
                                _finalPrice = '$209.95';
                            }
                        } else if (_ingredientsArray.includes("tacrolimus") && !_ingredientsArray.includes("dutasteride") && !_ingredientsArray.includes("latanoprost") && !_ingredientsArray.includes("bimatoprost")) {
                            if (_quantity == "30ml") {
                                _finalPrice = '$92.95';
                            } else if (_quantity == "60ml") {
                                _finalPrice = '$123.95';
                            } else {
                                _finalPrice = '$199.95';
                            }
                        } else if ((_ingredientsArray.includes("dutasteride") && _ingredientsArray.includes("latanoprost") && !_ingredientsArray.includes("bimatoprost"))
                                     || (_ingredientsArray.includes("dutasteride") && _ingredientsArray.includes("bimatoprost") && !_ingredientsArray.includes("latanoprost"))) {
                            if (_quantity == "30ml") {
                                _finalPrice = '$119.95';
                            } else if (_quantity == "60ml") {
                                _finalPrice = '$179.95';
                            } else {
                                _finalPrice = '$259.95';
                            }
                        } else if ( (_ingredientsArray.includes("tacrolimus") && _ingredientsArray.includes("dutasteride"))
                                    || (_ingredientsArray.includes("tacrolimus") && _ingredientsArray.includes("latanoprost"))
                                    || (_ingredientsArray.includes("tacrolimus") && _ingredientsArray.includes("bimatoprost")) ) {
                            if (_quantity == "30ml") {
                                _finalPrice = '$159.95';
                            } else if (_quantity == "60ml") {
                                _finalPrice = '$234.95';
                            } else {
                                _finalPrice = '$349.95';
                            }
                        } else if (_ingredientsArray.includes("minoxidil")) {
                            if (_quantity == "30ml") {
                                _finalPrice = '$44.95';
                            } else if (_quantity == "60ml") {
                                _finalPrice = '$59.95';
                            } else {
                                _finalPrice = '$94.95';
                            }
                        } else if (_ingredientsArray.includes("finasteride")) {
                            if (_quantity == "30ml") {
                                _finalPrice = '$44.95';
                            } else if (_quantity == "60ml") {
                                _finalPrice = '$59.95';
                            } else {
                                _finalPrice = '$94.95';
                            }
                        } else {
                            if (_quantity == "30ml") {
                                _finalPrice = '$55.95';
                            } else if (_quantity == "60ml") {
                                _finalPrice = '$65.95';
                            } else {
                                _finalPrice = '$105.95';
                            }
                        }
                    } else if (_ingredientsArray.length == 3) { //if 3 ingreds
                        if ((_ingredientsArray.includes("tacrolimus") && _ingredientsArray.includes("dutasteride") && _ingredientsArray.includes("latanoprost"))
                                    || (_ingredientsArray.includes("tacrolimus") && _ingredientsArray.includes("dutasteride") && _ingredientsArray.includes("bimatoprost"))) {
                            if (_quantity == "30ml") {
                                _finalPrice = '$199.95';
                            } else if (_quantity == "60ml") {
                                _finalPrice = '$279.95';
                            } else {
                                _finalPrice = '$404.95';
                            }
                        } else if (_ingredientsArray.includes("dutasteride") && !_ingredientsArray.includes("latanoprost") && !_ingredientsArray.includes("bimatoprost") && !_ingredientsArray.includes("tacrolimus")) {
                            if (_quantity == "30ml") {
                                _finalPrice = '$79.95';
                            } else if (_quantity == "60ml") {
                                _finalPrice = '$136.95';
                            } else {
                                _finalPrice = '$210.95';
                            }
                        } else if (_ingredientsArray.includes("latanoprost") && !_ingredientsArray.includes("dutasteride") && !_ingredientsArray.includes("bimatoprost") && !_ingredientsArray.includes("tacrolimus")) {
                            if (_quantity == "30ml") {
                                _finalPrice = '$89.95';
                            } else if (_quantity == "60ml") {
                                _finalPrice = '$139.95';
                            } else {
                                _finalPrice = '$229.95';
                            }
                        } else if (_ingredientsArray.includes("bimatoprost") && !_ingredientsArray.includes("dutasteride") && !_ingredientsArray.includes("latanoprost") && !_ingredientsArray.includes("tacrolimus")) {
                            if (_quantity == "30ml") {
                                _finalPrice = '$89.95';
                            } else if (_quantity == "60ml") {
                                _finalPrice = '$139.95';
                            } else {
                                _finalPrice = '$229.95';
                            }
                        } else if (_ingredientsArray.includes("tacrolimus") && !_ingredientsArray.includes("dutasteride") && !_ingredientsArray.includes("latanoprost") && !_ingredientsArray.includes("bimatoprost")) {
                            if (_quantity == "30ml") {
                                _finalPrice = '$99.95'
                            } else if (_quantity == "60ml") {
                                _finalPrice = '$129.95';
                            } else {
                                _finalPrice = '$209.95';
                            }
                        } else if ((_ingredientsArray.includes("dutasteride") && _ingredientsArray.includes("latanoprost") && !_ingredientsArray.includes("bimatoprost"))
                                     || (_ingredientsArray.includes("dutasteride") && _ingredientsArray.includes("bimatoprost") && !_ingredientsArray.includes("latanoprost"))) {
                            if (_quantity == "30ml") {
                                _finalPrice = '$159.95';
                            } else if (_quantity == "60ml") {
                                _finalPrice = '$189.95';
                            } else {
                                _finalPrice = '$269.95';
                            }
                        } else if ( (_ingredientsArray.includes("tacrolimus") && _ingredientsArray.includes("dutasteride") && !(_ingredientsArray.includes("bimatoprost") || _ingredientsArray.includes("latanoprost")))
                                    || (_ingredientsArray.includes("tacrolimus") && _ingredientsArray.includes("latanoprost") && !(_ingredientsArray.includes("dutasteride") || _ingredientsArray.includes("bimatoprost")))
                                    || (_ingredientsArray.includes("tacrolimus") && _ingredientsArray.includes("bimatoprost") && !(_ingredientsArray.includes("dutasteride") || _ingredientsArray.includes("latanoprost"))) ) {
                            if (_quantity == "30ml") {
                                _finalPrice = '$169.95';
                            } else if (_quantity == "60ml") {
                                _finalPrice = '$244.95';
                            } else {
                                _finalPrice = '$359.95';
                            }
                        } else if (_ingredientsArray.includes("minoxidil")) {
                            if (_quantity == "30ml") {
                                _finalPrice = '$49.95';
                            } else if (_quantity == "60ml") {
                                _finalPrice = '$64.95';
                            } else {
                                _finalPrice = '$104.95';
                            }
                        } else if (_ingredientsArray.includes("finasteride")) {
                            if (_quantity == "30ml") {
                                _finalPrice = '$49.95';
                            } else if (_quantity == "60ml") {
                                _finalPrice = '$64.95';
                            } else {
                                _finalPrice = '$104.95';
                            }
                        } else {
                            if (_quantity == "30ml") {
                                _finalPrice = '$60.95';
                            } else if (_quantity == "60ml") {
                                _finalPrice = '$70.95';
                            } else {
                                _finalPrice = '$110.95';
                            }
                        }
                    } else if (_ingredientsArray.length == 4) { //if 4 ingreds
                        if ((_ingredientsArray.includes("tacrolimus") && _ingredientsArray.includes("dutasteride") && _ingredientsArray.includes("latanoprost"))
                                    || (_ingredientsArray.includes("tacrolimus") && _ingredientsArray.includes("dutasteride") && _ingredientsArray.includes("bimatoprost"))) {
                            if (_quantity == "30ml") {
                                _finalPrice = '$199.95';
                            } else if (_quantity == "60ml") {
                                _finalPrice = '$279.95';
                            } else {
                                _finalPrice = '$404.95';
                            }
                        } else if (_ingredientsArray.includes("dutasteride") && !_ingredientsArray.includes("latanoprost") && !_ingredientsArray.includes("bimatoprost") && !_ingredientsArray.includes("tacrolimus")) {
                            if (_quantity == "30ml") {
                                _finalPrice = '$88.95';
                            } else if (_quantity == "60ml") {
                                _finalPrice = '$144.95';
                            } else {
                                _finalPrice = '$219.95';
                            }
                        } else if (_ingredientsArray.includes("latanoprost") && !_ingredientsArray.includes("dutasteride") && !_ingredientsArray.includes("bimatoprost") && !_ingredientsArray.includes("tacrolimus")) {
                            if (_quantity == "30ml") {
                                _finalPrice = '$96.95';
                            } else if (_quantity == "60ml") {
                                _finalPrice = '$147.95';
                            } else {
                                _finalPrice = '$236.95';
                            }
                        } else if (_ingredientsArray.includes("bimatoprost") && !_ingredientsArray.includes("dutasteride") && !_ingredientsArray.includes("latanoprost") && !_ingredientsArray.includes("tacrolimus")) {
                            if (_quantity == "30ml") {
                                _finalPrice = '$96.95';
                            } else if (_quantity == "60ml") {
                                _finalPrice = '$147.95';
                            } else {
                                _finalPrice = '$236.95';
                            }
                        } else if (_ingredientsArray.includes("tacrolimus") && !_ingredientsArray.includes("dutasteride") && !_ingredientsArray.includes("latanoprost") && !_ingredientsArray.includes("bimatoprost")) {
                            if (_quantity == "30ml") {
                                _finalPrice = '$109.95'
                            } else if (_quantity == "60ml") {
                                _finalPrice = '$139.95';
                            } else {
                                _finalPrice = '$219.95';
                            }
                        } else if ((_ingredientsArray.includes("dutasteride") && _ingredientsArray.includes("latanoprost") && !_ingredientsArray.includes("bimatoprost"))
                                     || (_ingredientsArray.includes("dutasteride") && _ingredientsArray.includes("bimatoprost") && !_ingredientsArray.includes("latanoprost"))) {
                            if (_quantity == "30ml") {
                                _finalPrice = '$139.95';
                            } else if (_quantity == "60ml") {
                                _finalPrice = '$199.95';
                            } else {
                                _finalPrice = '$279.95';
                            }
                        } else if ( (_ingredientsArray.includes("tacrolimus") && _ingredientsArray.includes("dutasteride") && !(_ingredientsArray.includes("bimatoprost") || _ingredientsArray.includes("latanoprost")))
                                    || (_ingredientsArray.includes("tacrolimus") && _ingredientsArray.includes("latanoprost") && !(_ingredientsArray.includes("dutasteride") || _ingredientsArray.includes("bimatoprost")))
                                    || (_ingredientsArray.includes("tacrolimus") && _ingredientsArray.includes("bimatoprost") && !(_ingredientsArray.includes("dutasteride") || _ingredientsArray.includes("latanoprost"))) ) {
                            if (_quantity == "30ml") {
                                _finalPrice = '$179.95';
                            } else if (_quantity == "60ml") {
                                _finalPrice = '$254.95';
                            } else {
                                _finalPrice = '$369.95';
                            }
                        } else if (_ingredientsArray.includes("minoxidil")) {
                            if (_quantity == "30ml") {
                                _finalPrice = '$59.95';
                            } else if (_quantity == "60ml") {
                                _finalPrice = '$69.95';
                            } else {
                                _finalPrice = '$109.95';
                            }
                        } else if (_ingredientsArray.includes("finasteride")) {
                            if (_quantity == "30ml") {
                                _finalPrice = '$59.95';
                            } else if (_quantity == "60ml") {
                                _finalPrice = '$69.95';
                            } else {
                                _finalPrice = '$109.95';
                            }
                        } else {
                            if (_quantity == "30ml") {
                                _finalPrice = '$65.95';
                            } else if (_quantity == "60ml") {
                                _finalPrice = '$75.95';
                            } else {
                                _finalPrice = '$115.95';
                            }
                        }
                    } else if (_ingredientsArray.length == 5) { //if 5 ingreds
                        if ((_ingredientsArray.includes("tacrolimus") && _ingredientsArray.includes("dutasteride") && _ingredientsArray.includes("latanoprost"))
                                    || (_ingredientsArray.includes("tacrolimus") && _ingredientsArray.includes("dutasteride") && _ingredientsArray.includes("bimatoprost"))) {
                            if (_quantity == "30ml") {
                                _finalPrice = '$199.95';
                            } else if (_quantity == "60ml") {
                                _finalPrice = '$279.95';
                            } else {
                                _finalPrice = '$404.95';
                            }
                        } else if (_ingredientsArray.includes("dutasteride") && !_ingredientsArray.includes("latanoprost") && !_ingredientsArray.includes("bimatoprost") && !_ingredientsArray.includes("tacrolimus")) {
                            if (_quantity == "30ml") {
                                _finalPrice = '$95.95';
                            } else if (_quantity == "60ml") {
                                _finalPrice = '$152.95';
                            } else {
                                _finalPrice = '$228.95';
                            }
                        } else if (_ingredientsArray.includes("latanoprost") && !_ingredientsArray.includes("dutasteride") && !_ingredientsArray.includes("bimatoprost") && !_ingredientsArray.includes("tacrolimus")) {
                            if (_quantity == "30ml") {
                                _finalPrice = '$104.95';
                            } else if (_quantity == "60ml") {
                                _finalPrice = '$156.95';
                            } else {
                                _finalPrice = '$244.95';
                            }
                        } else if (_ingredientsArray.includes("bimatoprost") && !_ingredientsArray.includes("dutasteride") && !_ingredientsArray.includes("latanoprost") && !_ingredientsArray.includes("tacrolimus")) {
                            if (_quantity == "30ml") {
                                _finalPrice = '$104.95';
                            } else if (_quantity == "60ml") {
                                _finalPrice = '$156.95';
                            } else {
                                _finalPrice = '$244.95';
                            }
                        } else if (_ingredientsArray.includes("tacrolimus") && !_ingredientsArray.includes("dutasteride") && !_ingredientsArray.includes("latanoprost") && !_ingredientsArray.includes("bimatoprost")) {
                            if (_quantity == "30ml") {
                                _finalPrice = '$119.95'
                            } else if (_quantity == "60ml") {
                                _finalPrice = '$149.95';
                            } else {
                                _finalPrice = '$229.95';
                            }
                        } else if ((_ingredientsArray.includes("dutasteride") && _ingredientsArray.includes("latanoprost") && !_ingredientsArray.includes("bimatoprost"))
                                     || (_ingredientsArray.includes("dutasteride") && _ingredientsArray.includes("bimatoprost") && !_ingredientsArray.includes("latanoprost"))) {
                            if (_quantity == "30ml") {
                                _finalPrice = '$149.95';
                            } else if (_quantity == "60ml") {
                                _finalPrice = '$109.95';
                            } else {
                                _finalPrice = '$289.95';
                            }
                        } else if ( (_ingredientsArray.includes("tacrolimus") && _ingredientsArray.includes("dutasteride") && !(_ingredientsArray.includes("bimatoprost") || _ingredientsArray.includes("latanoprost")))
                                    || (_ingredientsArray.includes("tacrolimus") && _ingredientsArray.includes("latanoprost") && !(_ingredientsArray.includes("dutasteride") || _ingredientsArray.includes("bimatoprost")))
                                    || (_ingredientsArray.includes("tacrolimus") && _ingredientsArray.includes("bimatoprost") && !(_ingredientsArray.includes("dutasteride") || _ingredientsArray.includes("latanoprost"))) ) {
                            if (_quantity == "30ml") {
                                _finalPrice = '$189.95';
                            } else if (_quantity == "60ml") {
                                _finalPrice = '$264.95';
                            } else {
                                _finalPrice = '$379.95';
                            }
                        } else if (_ingredientsArray.includes("minoxidil")) {
                            if (_quantity == "30ml") {
                                _finalPrice = '$69.95';
                            } else if (_quantity == "60ml") {
                                _finalPrice = '$84.95';
                            } else {
                                _finalPrice = '$119.95';
                            }
                        } else if (_ingredientsArray.includes("finasteride")) {
                            if (_quantity == "30ml") {
                                _finalPrice = '$69.95';
                            } else if (_quantity == "60ml") {
                                _finalPrice = '$84.95';
                            } else {
                                _finalPrice = '$119.95';
                            }
                        } else {
                            if (_quantity == "30ml") {
                                _finalPrice = '$70.95';
                            } else if (_quantity == "60ml") {
                                _finalPrice = '$80.95';
                            } else {
                                _finalPrice = '$120.95';
                            }
                        }
                    } else if (_ingredientsArray.length == 6) { //if 6 ingreds
                        if ((_ingredientsArray.includes("tacrolimus") && _ingredientsArray.includes("dutasteride") && _ingredientsArray.includes("latanoprost"))
                                    || (_ingredientsArray.includes("tacrolimus") && _ingredientsArray.includes("dutasteride") && _ingredientsArray.includes("bimatoprost"))) {
                            if (_quantity == "30ml") {
                                _finalPrice = '$199.95';
                            } else if (_quantity == "60ml") {
                                _finalPrice = '$279.95';
                            } else {
                                _finalPrice = '$404.95';
                            }
                        } else if (_ingredientsArray.includes("dutasteride") && !_ingredientsArray.includes("latanoprost") && !_ingredientsArray.includes("bimatoprost") && !_ingredientsArray.includes("tacrolimus")) {
                            if (_quantity == "30ml") {
                                _finalPrice = '$101.95';
                            } else if (_quantity == "60ml") {
                                _finalPrice = '$159.95';
                            } else {
                                _finalPrice = '$234.95';
                            }
                        } else if (_ingredientsArray.includes("latanoprost") && !_ingredientsArray.includes("dutasteride") && !_ingredientsArray.includes("bimatoprost") && !_ingredientsArray.includes("tacrolimus")) {
                            if (_quantity == "30ml") {
                                _finalPrice = '$113.95';
                            } else if (_quantity == "60ml") {
                                _finalPrice = '$163.95';
                            } else {
                                _finalPrice = '$253.95';
                            }
                        } else if (_ingredientsArray.includes("bimatoprost") && !_ingredientsArray.includes("dutasteride") && !_ingredientsArray.includes("latanoprost") && !_ingredientsArray.includes("tacrolimus")) {
                            if (_quantity == "30ml") {
                                _finalPrice = '$113.95';
                            } else if (_quantity == "60ml") {
                                _finalPrice = '$163.95';
                            } else {
                                _finalPrice = '$253.95';
                            }
                        } else if (_ingredientsArray.includes("tacrolimus") && !_ingredientsArray.includes("dutasteride") && !_ingredientsArray.includes("latanoprost") && !_ingredientsArray.includes("bimatoprost")) {
                            if (_quantity == "30ml") {
                                _finalPrice = '$129.95'
                            } else if (_quantity == "60ml") {
                                _finalPrice = '$159.95';
                            } else {
                                _finalPrice = '$239.95';
                            }
                        } else if ((_ingredientsArray.includes("dutasteride") && _ingredientsArray.includes("latanoprost") && !_ingredientsArray.includes("bimatoprost"))
                                     || (_ingredientsArray.includes("dutasteride") && _ingredientsArray.includes("bimatoprost") && !_ingredientsArray.includes("latanoprost"))) {
                            if (_quantity == "30ml") {
                                _finalPrice = '$159.95';
                            } else if (_quantity == "60ml") {
                                _finalPrice = '$219.95';
                            } else {
                                _finalPrice = '$299.95';
                            }
                        } else if ( (_ingredientsArray.includes("tacrolimus") && _ingredientsArray.includes("dutasteride") && !(_ingredientsArray.includes("bimatoprost") || _ingredientsArray.includes("latanoprost")))
                                    || (_ingredientsArray.includes("tacrolimus") && _ingredientsArray.includes("latanoprost") && !(_ingredientsArray.includes("dutasteride") || _ingredientsArray.includes("bimatoprost")))
                                    || (_ingredientsArray.includes("tacrolimus") && _ingredientsArray.includes("bimatoprost") && !(_ingredientsArray.includes("dutasteride") || _ingredientsArray.includes("latanoprost"))) ) {
                            if (_quantity == "30ml") {
                                _finalPrice = '$199.95';
                            } else if (_quantity == "60ml") {
                                _finalPrice = '$274.95';
                            } else {
                                _finalPrice = '$389.95';
                            }
                        } else if (_ingredientsArray.includes("minoxidil")) {
                            if (_quantity == "30ml") {
                                _finalPrice = '$79.95';
                            } else if (_quantity == "60ml") {
                                _finalPrice = '$94.95';
                            } else {
                                _finalPrice = '$129.95';
                            }
                        } else if (_ingredientsArray.includes("finasteride")) {
                            if (_quantity == "30ml") {
                                _finalPrice = '$79.95';
                            } else if (_quantity == "60ml") {
                                _finalPrice = '$94.95';
                            } else {
                                _finalPrice = '$129.95';
                            }
                        } else {
                            if (_quantity == "30ml") {
                                _finalPrice = '$75.95';
                            } else if (_quantity == "60ml") {
                                _finalPrice = '$85.95';
                            } else {
                                _finalPrice = '$125.95';
                            }
                        }
                    }

                    //OUTPUT
                    _ingredients = _ingredients.trim();
                    _strengths = _strengths.trim();
                    _ingredients = _ingredients.substring(0, _ingredients.length - 2);
                    _strengths = _strengths.substring(0, _strengths.length - 2);
                    var _image = _ingredients.replace(/\\s/g, '');
                    _image = _image.replaceAll('/', '-');
                    _ingredients.replace("azelaicacid", "Azelaic Acid");
                    $('#finished-product').html(\`
                        <img style="float:right;" src="/images/compound-hair.webp" alt="Custom Hairloss Product" />
                        <h3 style="font-weight:bold;">Ingredients:</h3><p class="capitalize">\` + _ingredients + \`</p>
                        <div class="clear-inline"></div>
                        <h3 style="font-weight:bold;">Strengths:</h3><p>\` + _strengths + \`</p>
                        <div class="clear-inline"></div>
                        <h3 style="font-weight:bold;">Form:</h3><p class="capitalize">\` + _form + \`</p>
                        <div class="clear-inline"></div>
                        <h3 style="font-weight:bold;">Quantity:</h3><p>\` + _quantity + \`</p>
                        <div class="clear-inline"></div>
                        <h3 style="font-weight:bold;">Price:</h3><p>\` + _finalPrice + \`</p>
                        <div class="clear-inline"></div>
                    \`);
                }
            });

            $('.ingredients').change(function() {
                //Find each element that is checked, store it in a string
                
                //show or hide the strengths
                if ($(this).is(':checked')) {
                    $(this).next().addClass('activeele');
                    $(this).next().children('input').each(function () {
                        $(this).attr('required',true);
                    });
                } else {
                    $(this).next().removeClass('activeele');
                    $(this).next().children('input').each(function () {
                        $(this).attr('required', false);
                        $(this).prop('checked', false);
                    });
                }


                var _checked = [];
                $(".ingredients").each(function(index){  
                    var input = $(this);
                    if ($(this).is(':checked')) {
                        _checked.push($(this).attr('id'));
                        //if input is checked, find child of sibling element and add required
                        var _strength = $(this).next().children().children();
                        _strength.prop("required", true);
                        _strength.prop("checked", true);
                    } else {
                        var _strength = $(this).next().children().children();
                        _strength.prop("required", false);
                        _strength.prop("checked", false);
                    }
                });
                if (_checked.length == 0) {
                    $('button[data-type="next"').prop('disabled', false);
                    $(".ingredients").each(function(index){  
                        var input = $(this);
                        $(this).prop('disabled', false);
                    });
                    $('#tretinoin-solo').hide();
                    $('#azelaicacid-solo').hide();
                    $('#fluocinonide-solo').hide();
                    $('#progesterone-solo').hide();
                    $('#estradiol-solo').hide();
                    $('#ketoconazole-solo').hide();
                    $('#biotin-solo').hide();
                    $('#tacrolimus-solo').hide();
                    $('#caffeine-solo').hide();
                    $('#cetirizine-solo').hide();
                    $('#niacinamide-solo').hide();
                    $('#spironolactone-solo').hide();
                    $('#steroid-solo').hide();
                } else if (_checked.length == 1) {  //if 1 ingred
                    $('#call-for-pricing').hide();
                    $('button[data-type="next"').prop('disabled', false);
                    if (_checked[0] == "tretinoin") {
                        $('button').prop('disabled', true);
                        $('#tretinoin-solo').show();
                    } else if (_checked[0] == "azelaicacid") {
                        $('button').prop('disabled', true);
                        $('#azelaicacid-solo').show();
                    } else if (_checked[0] == "fluocinonide") {
                        $('button').prop('disabled', true);
                        $('#fluocinonide-solo').show();
                    } else if (_checked[0] == "progesterone") {
                        $('button').prop('disabled', true);
                        $('#progesterone-solo').show();
                    } else if (_checked[0] == "estradiol") {
                        $('button').prop('disabled', true);
                        $('#estradiol-solo').show();
                    } else if (_checked[0] == "ketoconazole") {
                        $('button').prop('disabled', true);
                        $('#ketoconazole-solo').show();
                    } else if (_checked[0] == "biotin") {
                        $('button').prop('disabled', true);
                        $('#biotin-solo').show();
                    } else if (_checked[0] == "tacrolimus") {
                        $('button').prop('disabled', true);
                        $('#tacrolimus-solo').show();
                    } else if (_checked[0] == "caffeine") {
                        $('button').prop('disabled', true);
                        $('#caffeine-solo').show();
                    } else if (_checked[0] == "cetirizine") {
                        $('button').prop('disabled', true);
                        $('#cetirizine-solo').show();
                    } else if (_checked[0] == "niacinamide") {
                        $('button').prop('disabled', true);
                        $('#niacinamide-solo').show();
                    } else if (_checked[0] == "spironolactone") {
                        $('button').prop('disabled', true);
                        $('#spironolactone-solo').show();
                    } else if (_checked[0] == "steroid") {
                        $('button').prop('disabled', true);
                        $('#steroid-solo').show();
                    } else if (_checked[0] == "minoxidil") {
                        //$('#foam').prop('disabled', false);
                        //$('#solution').prop('disabled', false);
                        //$('#cream').prop('disabled', true);
                    } else if (_checked[0] == "finasteride") {
                        //$('#foam').prop('disabled', false);
                        //$('#solution').prop('disabled', false);
                        //$('#cream').prop('disabled', true);
                        $('#dutasteride').prop('disabled', true);
                    } else if (_checked[0] == "latanoprost") {
                        //$('#foam').prop('disabled', false);
                        //$('#solution').prop('disabled', false);
                        //$('#cream').prop('disabled', true);
                        $('#bimatoprost').prop('disabled', true);
                    } else if (_checked[0] == "dutasteride") {
                        //$('#foam').prop('disabled', true);
                        //$('#solution').prop('disabled', false);
                        //$('#cream').prop('disabled', true);
                        $('#finasteride').prop('disabled', true);
                    } else if (_checked[0] == "bimatoprost") {
                        //$('#foam').prop('disabled', false);
                        //$('#solution').prop('disabled', false);
                        //$('#cream').prop('disabled', true);
                        $('#latanoprost').prop('disabled', true);
                    }
                    if (!(_checked[0] == "bimatoprost")) {
                        $('#latanoprost').prop('disabled', false);
                    }
                    if (!(_checked[0] == "latanoprost")) {
                        $('#bimatoprost').prop('disabled', false);
                    }
                    if (!(_checked[0] == "finasteride")) {
                        $('#dutasteride').prop('disabled', false);
                    }
                    if (!(_checked[0] == "dutasteride")) {
                        $('#finasteride').prop('disabled', false);
                    }
                } else if (_checked.length >= 2 || _checked.length == 0) { //if 2 or more ingredients
                    $('button').prop('disabled', false);
                    $('#tretinoin-solo').hide();
                    $('#azelaicacid-solo').hide();
                    $('#fluocinonide-solo').hide();
                    $('#progesterone-solo').hide();
                    $('#estradiol-solo').hide();
                    $('#ketoconazole-solo').hide();
                    $('#biotin-solo').hide();
                    $('#tacrolimus-solo').hide();
                    $('#caffeine-solo').hide();
                    $('#cetirizine-solo').hide();
                    $('#niacinamide-solo').hide();
                    $('#spironolactone-solo').hide();
                    $('#steroid-solo').hide();
                    if (_checked.includes("latanoprost")) {
                        $('#bimatoprost').prop('disabled', true);
                    }
                    if (_checked.includes("bimatoprost")) {
                        $('#latanoprost').prop('disabled', true);
                    }
                    if (!_checked.includes("bimatoprost")) {
                        $('#latanoprost').prop('disabled', false);
                    }
                    if (!_checked.includes("latanoprost")) {
                        $('#bimatoprost').prop('disabled', false);
                    }
                    if (_checked.includes("finasteride")) {
                        $('#dutasteride').prop('disabled', true);
                    }
                    if (_checked.includes("dutasteride")) {
                        $('#finasteride').prop('disabled', true);
                    }
                    if (!_checked.includes("dutasteride")) {
                        $('#finasteride').prop('disabled', false);
                    }
                    if (!_checked.includes("finasteride")) {
                        $('#dutasteride').prop('disabled', false);
                    }
                    /*if (_checked.includes("tacrolimus") && (_checked.includes("bimatoprost") || _checked.includes("dutasteride") || _checked.includes("latanoprost"))) {
                        $('#call-for-pricing').show();
                        $('button[data-type="next"').prop('disabled', true);
                    } else {
                        $('#call-for-pricing').hide();
                        $('button[data-type="next"').prop('disabled', false);
                    }*/
                }


                if (_checked.length == 5) { //if 5 ingredients
                    //if we go back from 6 to 5, make sure all inputs enabled
                    
                    //disable the non-checked inputs
                    $(".ingredients").each(function(index){  
                        $(this).prop('disabled', false);
                    });

                    if (_checked.includes("bimatoprost")) {
                        $('#latanoprost').prop('disabled', true)
                    } else if (_checked.includes("latanoprost")) {
                        $('#bimatoprost').prop('disabled', true)
                    }

                } else if (_checked.length == 6) { //if 6 ingredients

                    //disable the non-checked inputs
                    $(".ingredients").each(function(index){  
                        var input = $(this);
                        if (!$(this).is(':checked')) {
                            $(this).prop('disabled', true);
                        }
                    });
                }

            });

            $('.tsf-wizard-1').tsfWizard({
                stepEffect: 'basic',
                stepStyle: 'style1',
                navPosition: 'top',
                validation: true,
                stepTransition: true,
                showButtons: true,
                showStepNum: true,
                height: 'auto',
                prevBtn: '<i class="fa fa-chevron-left"></i> PREV',
                nextBtn: 'NEXT <i class="fa fa-chevron-right"></i>',
                finishBtn: 'RESTART',
                disableSteps: 'none',
                onBeforeNextButtonClick: function(e, validation) {
                    console.log('onBeforeNextButtonClick');
                    console.log(validation);
                    //for return please write below code
                    //  e.preventDefault();
                },
                onAfterNextButtonClick: function(e, from, to, validation) {
                    console.log('onAfterNextButtonClick');
                },
                onBeforePrevButtonClick: function(e, from, to) {
                    console.log('onBeforePrevButtonClick');
                    console.log('from ' + from + ' to ' + to);
                    //  e.preventDefault();
                },
                onAfterPrevButtonClick: function(e, from, to) {
                    console.log('onAfterPrevButtonClick');
                    console.log('validation ' + from + ' to ' + to);
                },
                onBeforeFinishButtonClick: function(e, validation) {
                    console.log('onBeforeFinishButtonClick');
                    console.log('validation ' + validation);
                    //e.preventDefault();
                },
                onAfterFinishButtonClick: function(e, validation) {
                    console.log('onAfterFinishButtonClick');
                    console.log('validation ' + validation);
                }
            });
        })(jQuery);
    });
}
initHairWizard();
`;

const htmlContent = `
<p>Alopecia, or hair loss, is a common condition that many men and women face. There are many factors that can affect proper hair growth, such as genetics, hormones, environmental factors, etc. However, the most prevalent type of hair loss is androgenetic alopecia, which is also known as male or female pattern hair loss. This type of hair loss presents differently in men and women, but both occur due to genetic and hormonal causes. Before discussing male and female pattern hair loss, let’s discuss the normal hair growth cycle.</p>
<p style="text-align: center; margin: 0 auto;"><img src="/images/blog/hair-growth.jpg" alt="Stages of Alopecia" /></p>
<h2>What is the normal hair growth cycle?</h2>
<p>The cycle of normal hair growth is divided into 3 phases:</p>
<p style="text-align: center; margin: 0 auto;"><img src="/images/blog/hair-growth2.jpg" alt="Hair Growth Cycle" /></p>
<ol>
<li>Anagen phase, which is the growth phase, lasts between 2 to 8 years</li>
<li>Catagen phase, which is the regression phase, lasts between 2 to 3 weeks</li>
<li>Telogen phase, which is the resting phase, lasts between 3 months</li>
</ol>
<p>At the end of the telogen phase, hair falls out of the follicle and is replaced by a new hair. In a normal scalp, 80-90% of hair exists in the anagen phase, 10-20% in the telogen phase, and 1-2% in the catagen phase.</p>
<h2>Types of Hair Loss</h2>
<p>There are many classifications of hair loss, each describing the potential causes of hair loss.</p>
<ol>
<li><span style="font-weight: bold;">Androgenetic alopecia:</span> Androgenetic alopecia is the most common type of hair loss. For men, this hair loss can begin after puberty and progress over time, possibly leading to complete baldness. For women, this type causes hair thinning but rarely does it lead to complete baldness.</li>
<li><span style="font-weight: bold;">Alopecia areata:</span> Alopecia areata is a type of hair loss occurring due to an autoimmune condition. This means that the body attacks healthy cells, including the hair follicles. This prevents new hair from growing. This condition can affect children and adults, and it may occur without warning. Alopecia areata can progress to complete hair loss.</li>
<li><span style="font-weight: bold;">Anagen effluvium:</span> Anagen effluvium is a type of hair loss that is rapid and occurs due to medical treatment, such as chemotherapy. Cancer medications are strong and fast acting against killing cancer cells, but they also stop hair follicle production in the scalp and other body areas. However, once the chemotherapy ends, hair loss will typically be reversed.</li>
<li><span style="font-weight: bold;">Telogen effluvium:</span> Telogen effluvium is a type of hair loss where large numbers of follicles enter the resting phase of the growth cycle, but the next growth phase does not occur. This leads to hair falling out from the scalp, but no new hair growth occurring afterward. This type of loss is usually triggered by situations, such as thyroid imbalance, childbirth, fevers, surgery, iron deficiency, etc. Also, use of certain medications, such as isotretinoin and warfarin, may also contribute to this type of hair loss. If the trigger event is temporary, this hair loss is reversible. However, telogen effluvium is considered to be chronic if the hair loss lasts longer than 6 months.</li>
<li><span style="font-weight: bold;">Tinea Capitis:</span> Tinea capitis is a type of hair loss that occurs due to a fungal infection on the scalp. This condition, also known as scalp ringworm, causes hair to fall out in patches. These patches can lead to bald spots, which can get bigger over time. The areas affected by the ringworm often have a red scaly appearance, and it may be very itchy as well. Since this type of hair loss has specific symptoms, early treatment will provide great hair regrowth.</li>
<li><span style="font-weight: bold;">Cicatricial alopecia:</span> Cicatricial alopecia is a rare type of hair loss and is also known as scarring alopecia. In this condition, inflammation destroys hair follicles, causing scar tissue to form in the place of the follicle. Once the scar tissue forms, hair does not regrow. This type of hair loss may begin very slowly and symptoms may not be noticeable. However, some people may experience hair falling out all at once. Cicatricial alopecia can occur at any age and affects both men and women.</li>
<li><span style="font-weight: bold;">Traction alopecia:</span> Traction alopecia or cosmetic hair damage is a type of hair loss that occurs due to excessive hairstyling and use of treatments. People who routinely keep hairstyles that involve pulling the hair tight, such as cornrows or pigtails, can develop this type of alopecia. Also, those who routinely get hair treatments with hot oils or perms may also experience hair loss. If scarring develops from excessive hairstyling or treatments, hair loss may become permanent.</li>
</ol>
<h2 id="hair-pricing">Pricing For Your Custom Hair Loss Product</h2>
<div class="tsf-wizard tsf-wizard-1 top" data-step-effect="default-effect" data-step-index="0"><!-- BEGIN NAV STEP-->
<div class="tsf-nav-step"><!-- BEGIN STEP INDICATOR-->
<ul class="gsi-step-indicator triangle gsi-style-1">
<li class="current" data-target="step-1"><a href="#0"> <span class="number">1</span> <span class="desc"> <label>Ingredients</label> <span>Medication Ingredients</span> </span> </a></li>
<li data-target="step-2"><a href="#0"> <span class="number">2</span> <span class="desc"> <label>Form</label> <span>Medication Form</span> </span> </a></li>
<li data-target="step-3"><a href="#0"><span class="number">3</span><span class="desc"><label>Quantity</label><span>Mediation Quantity</span></span></a></li>
<li data-target="step-4"><a href="#0"><span class="number">4</span><span class="desc"><label>Your Custom Hair Loss Medication</label><span></span></span></a></li>
</ul>
</div>
<div class="tsf-container"><form class="tsf-content" style="height: auto; overflow-y: auto;" autocomplete="off">
<div class="tsf-step step-1 active default-effect">
<div class="tsf-step-content email-editor-elements-sortable ui-sortable">
<div class="bal-elements-list-item ui-draggable ui-draggable-handle"></div>
<div class="element-content">
<div class="form-group row required"><label class="col-xs-2 col-form-label" style="font-weight: bold; font-size: 1.1em; margin-bottom: 5px;" data-type="label">Ingredients</label>
<p style="margin-left: 20px;">If a strength you need isn't listed, please call us - we have more strength options available!</p>
<p style="margin-left: 20px;">Select up to 6 ingredients. If you need more than 6 ingredients for your medication, please call <a title="1-844-822-7379" href="18448227379">844-822-7379</a></p>
<div class="col-xs-10 form-group">
<div class="multiple"><label><label> <input id="azelaicacid" class="ingredients" name="ingredients" required="required" type="checkbox" value="azelaicacid" data-type="input" />Azelaic Acid</label></label>
<div id="azelaicacid-str" class="strengths"><label><input class="strength" name="azelaicacid-str" type="radio" value="up to 5%" data-type="input" data-parsley-group="block-0" />up to 5%</label></div>
<p id="azelaicacid-solo">This ingredient is recommended to be combined with another ingredient. Please select another ingredient to make a combination for optimal treatment.</p>
<br /> <label><label> <input id="biotin" class="ingredients" name="ingredients" required="required" type="checkbox" value="biotin" data-type="input" />Biotin</label></label>
<div id="biotin-str" class="strengths"><label><input class="strength" name="biotin-str" type="radio" value="up to 1%" data-type="input" data-parsley-group="block-0" />up to 1%</label></div>
<p id="biotin-solo">This ingredient is recommended to be combined with another ingredient. Please select another ingredient to make a combination for optimal treatment.</p>
<br /> <label><label> <input id="bimatoprost" class="ingredients" name="ingredients" required="required" type="checkbox" value="bimatoprost" data-type="input" />Bimatoprost</label></label>
<div id="bimatoprost-str" class="strengths"><label><input class="strength" name="bimatoprost-str" type="radio" value="up to 0.03%" data-type="input" data-parsley-group="block-0" />up to 0.03%</label></div>
<br /> <label><label> <input id="caffeine" class="ingredients" name="ingredients" required="required" type="checkbox" value="caffeine" data-type="input" />Caffeine</label></label>
<div id="caffeine-str" class="strengths"><label><input class="strength" name="caffeine-str" type="radio" value="up to 0.5%" data-type="input" data-parsley-group="block-0" />up to 0.5%</label></div>
<p id="caffeine-solo">This ingredient is recommended to be combined with another ingredient. Please select another ingredient to make a combination for optimal treatment.</p>
<br /> <label><label> <input id="cetirizine" class="ingredients" name="ingredients" required="required" type="checkbox" value="cetirizine" data-type="input" />Cetirizine HCL</label></label>
<div id="cetirizine-str" class="strengths"><label><input class="strength" name="cetirizine-str" type="radio" value="up to 1%" data-type="input" data-parsley-group="block-0" />up to 1%</label></div>
<p id="cetirizine-solo">This ingredient is recommended to be combined with another ingredient. Please select another ingredient to make a combination for optimal treatment.</p>
<br /> <label><label> <input id="dutasteride" class="ingredients" name="ingredients" required="required" type="checkbox" value="dutasteride" data-type="input" />Dutasteride</label></label>
<div id="dutasteride-str" class="strengths"><label><input class="strength" name="dutasteride-str" type="radio" value="up to 0.5%" data-type="input" data-parsley-group="block-0" />up to 1%</label></div>
<br /> <label><label> <input id="estradiol" class="ingredients" name="ingredients" required="required" type="checkbox" value="estradiol" data-type="input" />Estradiol</label></label>
<div id="estradiol-str" class="strengths"><label><input class="strength" name="estradiol-str" type="radio" value="up to 0.025%" data-type="input" data-parsley-group="block-0" />up to 0.025%</label></div>
<p id="estradiol-solo">This ingredient is recommended to be combined with another ingredient. Please select another ingredient to make a combination for optimal treatment.</p>
<br /> <label><label> <input id="finasteride" class="ingredients" name="ingredients" required="required" type="checkbox" value="finasteride" data-type="input" />Finasteride</label></label>
<div id="finasteride-str" class="strengths"><label><input class="strength" name="finasteride-str" type="radio" value="up to 0.1%" data-type="input" data-parsley-group="block-0" />up to 0.1%</label></div>
<br /> <label><label> <input id="ketoconazole" class="ingredients" name="ingredients" required="required" type="checkbox" value="ketoconazole" data-type="input" />Ketoconazole</label></label>
<div id="ketoconazole-str" class="strengths"><label><input class="strength" name="ketoconazole-str" type="radio" value="up to 2%" data-type="input" data-parsley-group="block-0" />up to 2%</label></div>
<p id="ketoconazole-solo">This ingredient is recommended to be combined with another ingredient. Please select another ingredient to make a combination for optimal treatment.</p>
<br /> <label><label> <input id="latanoprost" class="ingredients" name="ingredients" required="required" type="checkbox" value="finasteride" data-type="input" />Latanoprost</label></label>
<div id="latanoprost-str" class="strengths"><label><input class="strength" name="latanoprost-str" type="radio" value="up to 0.01%" data-type="input" data-parsley-group="block-0" />up to 0.01%</label></div>
<br /> <label><label> <input id="minoxidil" class="ingredients" name="ingredients" required="required" type="checkbox" value="minoxidil" data-type="input" />Minoxidil</label></label>
<div id="minoxidil-str" class="strengths"><label><input class="strength" name="minoxidil-str" type="radio" value="up to 10%" data-type="input" data-parsley-group="block-0" />up to 10%</label></div>
<br /> <label><label> <input id="niacinamide" class="ingredients" name="ingredients" required="required" type="checkbox" value="niacinamide" data-type="input" />Niacinamide</label></label>
<div id="niacinamide-str" class="strengths"><label><input class="strength" name="niacinamide-str" type="radio" value="up to 2%" data-type="input" data-parsley-group="block-0" />up to 2%</label></div>
<p id="niacinamide-solo">This ingredient is recommended to be combined with another ingredient. Please select another ingredient to make a combination for optimal treatment.</p>
<br /> <label><label> <input id="progesterone" class="ingredients" name="ingredients" required="required" type="checkbox" value="progesterone" data-type="input" />Progesterone</label></label>
<div id="progesterone-str" class="strengths"><label><input class="strength" name="progesterone-str" type="radio" value="up to 0.5%" data-type="input" data-parsley-group="block-0" />up to 0.5%</label></div>
<p id="progesterone-solo">This ingredient is recommended to be combined with another ingredient. Please select another ingredient to make a combination for optimal treatment.</p>
<br /> <label><label> <input id="spironolactone" class="ingredients" name="ingredients" required="required" type="checkbox" value="spironolactone" data-type="input" />Spironolactone</label></label>
<div id="spironolactone-str" class="strengths"><label><input class="strength" name="spironolactone-str" type="radio" value="up to 5%" data-type="input" data-parsley-group="block-0" />up to 5%</label></div>
<p id="spironolactone-solo">This ingredient is recommended to be combined with another ingredient. Please select another ingredient to make a combination for optimal treatment.</p>
<br /> <label><label> <input id="tacrolimus" class="ingredients" name="ingredients" required="required" type="checkbox" value="tacrolimus" data-type="input" />Tacrolimus</label></label>
<div id="tacrolimus-str" class="strengths"><label><input class="strength" name="tacrolimus-str" type="radio" value="up to 0.1%" data-type="input" data-parsley-group="block-0" />up to 0.1%</label></div>
<p id="tacrolimus-solo">This ingredient is recommended to be combined with another ingredient. Please select another ingredient to make a combination for optimal treatment.</p>
<br /> <label><label> <input id="tretinoin" class="ingredients" name="ingredients" required="required" type="checkbox" value="tretinoin" data-type="input" />Tretinoin</label></label>
<div id="tretinoin-str" class="strengths"><label><input class="strength" name="tretinoin-str" type="radio" value="up to 0.01%" data-type="input" data-parsley-group="block-0" />up to 0.01%</label></div>
<p id="tretinoin-solo">This ingredient is recommended to be combined with another ingredient. Please select another ingredient to make a combination for optimal treatment.</p>
<br /> <label><label> <input id="steroid" class="ingredients" name="ingredients" required="required" type="checkbox" value="steroid" data-type="input" />Steroid (Betamethosone Val, Clobetasol, Fuocinonide, Fluocinolone, Hydrotortosone)</label></label>
<div id="steroid-str" class="strengths"><label><input class="strength" name="steroid-str" type="radio" value="0.025% to 1%" data-type="input" data-parsley-group="block-0" />0.025% to 1%</label></div>
<p id="steroid-solo">This ingredient is recommended to be combined with another ingredient. Please select another ingredient to make a combination for optimal treatment.</p>
</div>
<p id="call-for-pricing">Please call for pricing</p>
</div>
</div>
</div>
</div>
</div>
<!-- END STEP 1--> <!-- BEGIN STEP 2-->
<div class="tsf-step step-2"><!-- BEGIN STEP CONTENT-->
<div class="tsf-step-content email-editor-elements-sortable ui-sortable">
<div class="bal-elements-list-item ui-draggable ui-draggable-handle"></div>
<div class="bal-elements-list-item ui-draggable ui-draggable-handle"></div>
<div class="element-content"><!-- Text -->
<div class="form-group row"><label class="col-xs-2 col-form-label" style="font-weight: bold; font-size: 1.1em; margin-bottom: 5px;" data-type="label">Medication Form</label>
<div class="col-xs-10">
<div class="multiple"><!--<label><input id="cream" name="form" value="cream" type="radio" data-type="input" class="form" />Cream</label>
                                    <br />--> <label><input id="foam" class="form" name="form" type="radio" value="foam" data-type="input" />Foam</label> <br /> <label><input id="solution" class="form" name="form" type="radio" value="solution" data-type="input" />Solution/Suspension</label></div>
<span class="help-block" data-type="help">Please select the form for your medication</span></div>
</div>
</div>
</div>
<!-- END STEP CONTENT--></div>
<!-- END STEP 2--> <!--</form>-->
<div class="tsf-step step-3">
<div class="tsf-step-content email-editor-elements-sortable ui-sortable">
<div class="element-content"><!-- Text -->
<div class="form-group row"><label class="col-xs-2 col-form-label" style="font-weight: bold; font-size: 1.1em; margin-bottom: 5px;" data-type="label">Quantity</label>
<div class="col-xs-10">
<div class="multiple"><label> <input id="30ml" class="quantity" name="quantity" type="radio" value="30ml" data-type="input" />30ml</label> <br /> <label> <input id="60ml" class="quantity" name="quantity" type="radio" value="60ml" data-type="input" />60ml</label> <br /> <label> <input id="120ml" class="quantity" name="quantity" type="radio" value="120ml" data-type="input" />120ml</label></div>
<span class="help-block" data-type="help">Please select the quantity for your medication</span></div>
</div>
</div>
</div>
</div>
<div class="tsf-step step-4">
<div class="tsf-step-content email-editor-elements-sortable ui-sortable">
<div class="element-content">
<div class="form-group">
<h1 class="element-contenteditable active" style="font-weight: normal;">Your Custom Hair Loss Medication</h1>
<div id="finished-product"></div>
<p style="font-weight: bold; font-size: 1.2em;">CareFirst Specialty Pharmacy does not have doctors on staff to prescribe medications. If you have a provider that you would like for us to contact regarding this medication request, please fill out a patient registration form and provide us their contact information.</p>
<p><a id="contact-us-button" title="Contact Us" href="/contact/">Contact Us</a></p>
</div>
</div>
</div>
</div>
</form><!-- END CONTENT--> <!-- BEGIN CONTROLS-->
<div class="tsf-controls " style="display: block;"><!-- BEGIN PREV BUTTTON--> <button class="btn btn-left tsf-wizard-btn" type="button" data-type="prev"><i class="fa fa-chevron-left"></i> PREV</button> <!-- END PREV BUTTTON--> <!-- BEGIN NEXT BUTTTON--> <button class="btn btn-right tsf-wizard-btn" style="display: none;" type="button" data-type="next">NEXT <i class="fa fa-chevron-right"></i></button> <!-- END NEXT BUTTTON--> <!-- BEGIN FINISH BUTTTON--> <button id="finish-button" class="btn btn-right tsf-wizard-btn" type="submit" data-type="finish">RESTART</button> <!-- END FINISH BUTTTON--></div>
<!-- END CONTROLS--></div>
<!-- END STEP CONTAINER --></div>
<h2>Why do men lose hair?</h2>
<p>Male pattern hair loss, or male androgenetic alopecia, is one of the main causes of hair loss in adult men. Often, men experience this hair loss beginning from their frontal hairline and the crown of the head, causing them to have a U-shaped baldness.</p>
<p>In terms of onset, male pattern hair loss tends to start around ages 20-40, especially for those who have a genetic component to their hair loss. A second peak of cases is commonly seen in men aged 50 to 60 years. In advanced conditions, some might start seeing hair loss at the beginning of puberty.</p>
<p>The key player of male pattern hair loss or androgenetic alopecia is testosterone. This hormone is an androgen, meaning that it contributes to providing male traits and male reproductive activity. Testosterone is converted into 5-DHT (dihydrotesterone), which is a more potent form of the hormone. Although these hormones play a role in the development of male characteristics, too much free DHT may become a problem for some males and even females. DHT can bind to receptors on the hair follicles, causing them to shrink. DHT can also shorten the hair growth cycle, causing hair to become thinner and brittle.</p>
<p>The reason behind male pattern hair loss is multifactorial. Some potential causes are:</p>
<ol>
<li><span style="font-weight: bold;">Genetics:</span> Genetic variations in the hair follicle receptor can cause some men to have smaller hair follicles, which can shrink. This leads to hair growth to become shorter and thinner, until no new hairs grow. Men with more family members that have hair loss are more likely to have hair loss themselves.</li>
<li><span style="font-weight: bold;">Hormonal:</span> DHT, a potent form of testosterone, can cause many men to have hair loss, as this hormone can cause the hair follicles to shrink. Men can also have certain medical conditions that affect hormones, such as hypothyroidism, diabetes, etc.</li>
<li><span style="font-weight: bold;">Medications, chemotherapy:</span> Some medications might induce hair loss, such as statins (cholesterol medication), amiodarone (arrhythmia medication), colchicine (gout medication), hormones (testosterone) etc. Chemotherapy is meant to kill cancer cells, but other healthy cells may become targeted as well. Thus, many people with chemotherapy tend to have hair loss as their hair follicles are being damaged.</li>
<li><span style="font-weight: bold;">Age:</span> As the body gets older, cell growth begins to slow down. Cells in the hair follicles begin to grow slower and slower, causing the rate of cell death to be faster than the rate of cell growth.</li>
<li><span style="font-weight: bold;">Stress:</span> Stress can cause hair follicles to be pushed into the resting phase, preventing any new hair growth.</li>
<li><span style="font-weight: bold;">Diet:</span> Men who have diets with low nutrients may also experience hair loss. Vitamins and minerals, such iron, biotin, zinc, and vitamin D, play important roles in maintaining hair growth. Deficiencies in these nutrients can lead to hair thinning and eventual hair loss.</li>
</ol>
<h2>Why do women lose hair?</h2>
<p>Female pattern hair loss, or female androgenetic alopecia, is one of the main causes of hair loss in adult women. This type of alopecia is considered as a “non scarring diffuse alopecia”, meaning that hair follicles become smaller over time, which further leads to thinning hair. Often, women experience this hair loss in the top and crown of their head, with the front hairline affected in advanced stages.</p>
<p>In terms of onset, female pattern hair loss tends to start during the reproductive years, causing many patients aged 25-40 years to seek treatment. A second peak of cases is commonly seen in menopausal women aged 50 to 60 years. In advanced conditions, some might start seeing hair loss at the beginning of puberty.</p>
<p>In the female pattern hair loss, the growth phase becomes shorter and the thick hairs get replaced by miniaturized hairs. Also, the time between the resting and the next growth phase becomes longer, thus hair loss exceeds hair growth. This extra resting phase is called the kenogen phase, which means that the hair follicle remains empty.</p>
<p>The reason behind female pattern hair loss is multifactorial. Some potential causes are:</p>
<ol>
<li><span style="font-weight: bold;">Genetics:</span> Hereditary hair loss usually starts after age 40 for women, and it typically progresses slowly. Many women might find their hair parting is wider or their frontal hairline is further back than before.</li>
<li><span style="font-weight: bold;">Hormonal:</span> Hormones play a huge role in hair growth. Pregnancy and menopause can cause sudden hormone changes, where some may experience hair growth but some may have sudden hair loss. Health conditions, such as PCOS and hypothyroidism, can cause hormone imbalances, which increases the risk of hair loss.</li>
<li><span style="font-weight: bold;">Medications, chemotherapy:</span> Some medications might induce hair loss, such as statins (cholesterol medication), amiodarone (arrhythmia medication), colchicine (gout medication), etc. Chemotherapy is meant to kill cancer cells, but other healthy cells may become targeted as well. Thus, many people with chemotherapy tend to have hair loss as their hair follicles are being damaged.</li>
<li><span style="font-weight: bold;">Hair styling that could damage the hair follicles:</span> Routine hair styling with heat can damage hair follicles, causing hair to thin and fall out. Also, those who have their hair in braids, weave, twists, and tight ponytails are more likely to have hair loss due to intense pressure on their hair roots. This pressure can damage the follicles, causing scarring and potential permanent hair loss.</li>
<li><span style="font-weight: bold;">Age:</span> Hair aging can begin after age 60, in which hair becomes thinner and fewer in number. Also, hair growth begins to slow down, causing the rate of hair loss to be higher than the rate of hair growth.</li>
<li><span style="font-weight: bold;">Stress:</span> Stress causes the body to enter “fight mode”, where the body prioritizes it energy for vital functions. Stress can cause hair follicles to move to or remain in the resting state, causing hair to fall out. Stressors, such as illness, death, medication changes, extreme weight loss, etc can cause potential hair loss. However, once the stress is lessened, hair will begin to grow again.</li>
<li><span style="font-weight: bold;">Diet:</span> Extreme dieting can cause sudden weight loss, which can put stress on the body, prompting it to focus on survival. Also, dieting can affect nutrient intake, which may cause the hair to not have essential vitamins and minerals needed for healthy growth.</li>
</ol>
<p><img src="/images/hero-haircare.jpg" alt="Hair Care" /></p>
<h2>Treatments:</h2>
<p>The following medications can be combined into customized hair growth products of your doctor’s choosing. Various formulations are available, such as hair loss shampoos, creams, foams, gels, etc.</p>
<ol>
<li><span style="font-weight: bold;">Minoxidil</span><br /> Minoxidil is one of the most commonly used medications for hair loss in men and women. It works by prolonging the growth or anagen phase of hair growth cycle. This medication is androgen or hormone independent, thus making it safe to use for pregnant women as well. Some common side effects include scalp dryness, itching, and irritation. The irritation is commonly associated with inactive ingredients, such as propylene glycol, which are present in commercially available formulations.</li>
<li><span style="font-weight: bold;">Finasteride/Dutasteride</span><br /> Finasteride and Dutasteride are hormone or androgen dependent medications commonly used for hair loss in both men and women. They both work by inhibiting the 5 alpha reductase enzyme, which prevents the conversion of testosterone to the more potent 5-DHT. This medication should not be used by pregnant women. Some common side effects include breast tenderness and decreased libido.</li>
<li><span style="font-weight: bold;">Spironolactone</span><br /> Spironolactone is a hormone or androgen dependent medication used to treat hair loss in both men and women. This medication has an anti-androgen effect, as it decreases testosterone levels and blocks androgen receptors in target areas. Some common side effects include breast tenderness and high potassium levels. It should not be used with pregnant women.</li>
<li><span style="font-weight: bold;">Cetirizine</span><br /> Cetirizine is histamine-1 receptor blocker, commonly used for allergies. However, it also shows activity against prostaglandin D2 production, which is known to inhibit hair growth. By inhibiting prostaglandin D2, cetirizine can promote hair growth.</li>
<li><span style="font-weight: bold;">Tretinoin</span><br /> Tretinoin is a vitamin A derivative, commonly used for acne. However, studies have shown that Tretinoin enhances the response of Minoxidil, one of the most common medications used for hair loss.</li>
<li><span style="font-weight: bold;">Latanoprost/Bimatoprost</span><br /> Latanoprost and Bimatoprost are prostaglandin analogs used to treat hair loss in both men and women. They work by prolonging the hair growth phase, allowing hair to grow for a longer period of time. These medications are used commonly for glaucoma, but a side effect of eyelash hair growth was seen, prompting its use for hair growth.</li>
<li><span style="font-weight: bold;">Ketoconazole</span><br /> Ketoconazole is an antifungal medication that is used to treat hair loss in both men and women. It works by having anti-androgenic activity and decreases hair follicle DHT levels. It is commonly available as a hair loss shampoo.</li>
<li><span style="font-weight: bold;">Corticosteroids</span><br /> Corticosteroids can be used for patients who have hair loss due to an autoimmune condition. These medications can suppress the immune system, preventing the body from killing healthy hair cells. Steroids are available in topical form, with common side effects of scalp irritation and redness.</li>
<li><span style="font-weight: bold;">Progesterone</span><br /> Progesterone is heavily involved in hormone regulation. Systemically, progesterone can decrease androgen synthesis, causing lower levels of testosterone in the body. Locally at the hair follicle itself, progesterone can decrease the conversion of testosterone to the more potent DHT, preventing damage to the follicle.</li>
<li><span style="font-weight: bold;">Azelaic Acid</span><br /> Azelaic acid is an acid that is produced naturally by yeast on the skin. It plays a role in hair growth as it has been found to inhibit 5-alpha reductase, which prevents the formation of DHT.</li>
<li><span style="font-weight: bold;">Biotin</span><br /> Biotin is a type of B vitamin. It is often used for hair growth, as some people have hair loss related to nutrient deficiencies. However, biotin is effective if these deficiencies exist, as it has no effect on DHT and the hormonal process of hair growth.</li>
</ol>
<h2>Availability</h2>
<p>All of these medications may be available at your regular pharmacy. However, you may need a specialized combination of different medications to treat your hair loss. At CareFirst Specialty Pharmacy, we have the capability to specially compound unique combinations that you may need for optimal treatment. We work to provide you medications that are specific to your treatment needs. Reach out to your dermatologist to obtain a prescription today!</p>
<h2>References:</h2>
<ol>
<li>Ramos PM, Miot HA. Female pattern hair loss: a clinical and pathophysiological review. <span style="font-style: italic;">An Bras Dermatol.</span> 2015; 90(4):529-543. doi: 10.1590/abd1806-4841.20153370.</li>
<li>Dinh QQ, Sinclair R. Female pattern hair loss: current treatment concepts. <span style="font-style: italic;">Clin Interv Aging.</span> 2007; 2(2): 189-199. <a title="NCBI" href="https://www.ncbi.nlm.nih.gov/pmc/articles/PMC2684510/">https://www.ncbi.nlm.nih.gov/pmc/articles/PMC2684510/</a>.</li>
<li>Kelly Y, Blanco A, Tosti A. Androgenetic alopecia: an update of treatment options. <span style="font-style: italic;">Drugs.</span> 2016; 76: 134901364. <a title="Springer" href="https://link.springer.com/article/10.1007/s40265-016-0629-5">https://link.springer.com/article/10.1007/s40265-016-0629-5</a>.</li>
<li>Hair Loss in Women. Clevelandclinic.org. <a title="Cleveland Clinic" href="https://my.clevelandclinic.org/health/diseases/16921-hair-loss-in-women">https://my.clevelandclinic.org/health/diseases/16921-hair-loss-in-women</a>. Updated February 10 2021.</li>
<li>Hair loss-symptoms and causes. Mayoclinic.org. <a title="Mayo Clinic" href="https://www.mayoclinic.org/diseases-conditions/hair-loss/symptoms-causes/syc-20372926">https://www.mayoclinic.org/diseases-conditions/hair-loss/symptoms-causes/syc-20372926</a>. Updated May 22, 2020.</li>
<li>Wilson DR. Hair Loss and Testosterone. Healthline.com. <a title="Healthline" href="https://www.healthline.com/health/hair-loss-and-testosterone">https://www.healthline.com/health/hair-loss-and-testosterone</a>. Updated August 22 2018.</li>
<li>Carter A. What you need to know about DHT and hair loss. Healthline.com. <a title="Healthline" href="https://www.healthline.com/health/dht">https://www.healthline.com/health/dht</a>. Updated January 10 2019.</li>
<li>Rossi A, Campo D, Fortuna MC, et al. A preliminary study on topical cetirizine in the therapeutic management of androgenetic alopecia. <span style="font-style: italic;">Journal of Dermatological Treatment.</span> 2018; 29(2):149-151. DOI: 10.1080/09546634.2017.1341610</li>
<li>Sharma A, Goren A, Dhurat R, et al. Tretinoin enhances minoxidil response in androgenetic alopecia patients by upregulating follicular sulfotransferase enzymes. <span style="font-style: italic;">Dermatologic Therapy.</span> 2019; 32: e12915. doi: <a title="DOI" href="https://doi.org/10.1111/dth.12915">https://doi.org/10.1111/dth.12915</a></li>
<li>Types of hair loss. Nyulangone.org. <a title="Nyulangone" href="https://nyulangone.org/conditions/hair-loss/types">https://nyulangone.org/conditions/hair-loss/types</a>. Accessed March 24, 2021.</li>
<li>Mikhail M. Hair loss in women-most common causes by age. Goodrx.com. <a title="GoodRX" href="https://www.goodrx.com/blog/most-common-causes-of-hair-loss-in-women-by-age/">https://www.goodrx.com/blog/most-common-causes-of-hair-loss-in-women-by-age/</a>. Updated February 27, 2020. Accessed March 24, 2021.</li>
<li>Grymowicz M, Rudnicka E, Podfigurna A, et al. Hormonal effects on hair follicles. <span style="font-style: italic;">Int J Mol Sci.</span> 2020; 21(15): 5342. doi: 10.3390/ijms21155342.</li>
<li>Image 1: male vs female pattern baldness. Retrieved from: https://www.merckmanuals.com/-/media/manual/professional/images/skn_losing_hair.gif?mw=704&thn=0&sc_lang=en-ca</li>
<li>Image 2: hair growth cycle. Retrieved from: 599660-What-Are-the-Four-Stages-of-Hair-Growth_-1296x927-Body.png.</li>
</ol>
`;

export default function HairLossContent() {
  return (
    <main className="bg-gradient-to-b from-white via-[#f6faf8] to-[#eef7ff] text-[#1f3d1f] min-h-screen">
      <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css" />
      <link rel="stylesheet" href="/css/parsley.css" />
      <link rel="stylesheet" href="/css/tsf.css" />
      <link rel="stylesheet" href="/css/tsf-wizard.bundle.min.css" />
      <Script src="https://cdnjs.cloudflare.com/ajax/libs/jquery/3.6.4/jquery.min.js" strategy="afterInteractive" />
      <Script src="/js/parsley.min.js" strategy="afterInteractive" />
      <Script src="/js/tsf-wizard.bundle.min.js" strategy="afterInteractive" />
      <Script id="custom-hair-loss-inline" strategy="afterInteractive" dangerouslySetInnerHTML={{ __html: inlineScript }} />

      <section className="relative overflow-hidden border-b border-gray-200">
        <div className="absolute -left-24 -top-24 h-56 w-56 rounded-full bg-[#9fce8a]/30 blur-3xl" aria-hidden />
        <div className="absolute -right-24 bottom-0 h-64 w-64 rounded-full bg-[#01A6DE]/15 blur-3xl" aria-hidden />
        <div className="relative mx-auto max-w-6xl px-4 lg:px-8 py-12 space-y-3">
          <p className="text-sm font-semibold uppercase tracking-[0.12em] text-[#2f4f2f]">Custom Hair Loss</p>
          <h1 className="text-3xl md:text-4xl font-bold">Build Your Custom Hair Loss Medication</h1>
          <p className="text-lg text-[#3f3f3f]">
            Select ingredients, strengths, form, and quantity to see pricing for your personalized formulation.
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-6xl px-4 lg:px-8 py-10">
        <style dangerouslySetInnerHTML={{ __html: inlineStyles }} />
        <div className="rounded-2xl border border-[#d9eadb] bg-white shadow-lg shadow-[#9fce8a]/20 p-6 md:p-8">
          <div className="prose max-w-none prose-headings:text-[#1f3d1f] prose-p:text-[#2f2f2f] prose-ol:text-[#2f2f2f] prose-ul:text-[#2f2f2f]">
            <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
          </div>
        </div>
      </section>
    </main>
  );
}
